import { Response } from 'superagent'

export type ShopEntryErrorCode = 'entry_rejected' // 入店拒否
export type UnknownErrorCode = 'unknown'

export interface ShopEntryApiErrorResponseInterface {
  errorCode: ShopEntryErrorCode | UnknownErrorCode
  message: string
}

export class ShopEntryApiErrorResponse implements ShopEntryApiErrorResponseInterface {
  public static fromResponse(response: Response): ShopEntryApiErrorResponse {
    const body = response.body

    return new ShopEntryApiErrorResponse(body.error_code || 'unknown', body.message || '')
  }

  public static fromString(message: string): ShopEntryApiErrorResponse {
    return new ShopEntryApiErrorResponse('unknown', message)
  }

  constructor(
    public readonly errorCode: ShopEntryErrorCode | UnknownErrorCode,
    public readonly message: string
  ) {}
}
